import {  useFormikContext } from 'formik';
import React, { useState, useEffect } from 'react';
import Select from '../Form/Selector';
import { useEdit } from '../../Services/EditContext';
import { FormLabel, FormValue } from '../Form/FormLabel';
import { FormGroup } from 'reactstrap';
import ErrorMessage from './ErrorMessage'
import {getIn} from 'formik'
const StringSelector = ({ label, id, list, isMulti, stringType, options, ...myProps }  ) => {
  
    const [selection, setSelection] = useState();
    const [selectOptions, setOptions] = useState(options);
    const { setFieldValue, values } = useFormikContext();
    const [edit] = useEdit();

  
    const value = getIn( values,id);
    useEffect(() => {
        if (list) {
            const options = stringType ? list?.map((m) => {
                return { value: m, label: m }
            }) : list?.map((m) => { return { value: m.value, label: m.value }; });
            setOptions(options)
        }
    }, [list,stringType]);
    useEffect(() => {
        if (options) {
            setOptions(options)
        }
    }, [options]);
    useEffect(() => {
        if (selectOptions && value) {
            if (!isMulti) {
                setSelection(selectOptions.filter(x => { return value === x.label }));
            } else {

                const list = value.split(',');
                const newOps = list.map(x => selectOptions.find(y => x === y.value)).filter(Boolean);
                setSelection(newOps)
            }
        } else {
            setSelection(isMulti ? [] : undefined);
        }
    }, [value, selectOptions,isMulti])
    const onSelectChange = val => {
        if (!isMulti) {
            setFieldValue(id, val?.label ?? '');
        }
        else {
            setFieldValue(id, val ? val.map((x)=> x.value).join(',') : '')
        }
    }
    return <FormGroup>
        <FormLabel htmlFor={id} style={{ display: 'block' }}>
            {label}
        </FormLabel>
        {edit ? <Select id={id} onChange={onSelectChange} isMulti={isMulti} value={selection} options={selectOptions} {...myProps} /> : <FormValue>{value}</FormValue>}
        <ErrorMessage name={id} />
    </FormGroup>
};
export default StringSelector;

